import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { useAlert } from 'react-alert';
import { useSelector } from 'react-redux';
import I18n from 'i18n-js';

import { TStore } from '@lootboy/lib/types/store';

import Alert from '~/components/Alert';
import { EPlatform } from '~/components/molecules/PlatformButton';

import { getAuthProviderUri } from '~/popups/LoginPopup/useLoginView';
import { parseLootBoyError } from '~/utilities/errors';

type TSocialRegisterState = {
  captcha: {
    isRequired: boolean;
    onChange: (key: string) => Promise<void>;
    dismiss: () => void;
  };
  setSelectedProvider: Dispatch<SetStateAction<EPlatform | undefined>>;
};

export function useSocialRegister(): TSocialRegisterState {
  const alert = useAlert();
  const apiUrl = useSelector<TStore, string>(({ auth }) => auth.apiUrl);
  const [selectedProvider, setSelectedProvider] = useState<
    EPlatform | undefined
  >();

  const onCaptchaChange = useCallback(
    async (key: string) => {
      if (!selectedProvider) return;
      try {
        window.location.href = await getAuthProviderUri(
          selectedProvider,
          apiUrl,
          key,
        );
      } catch (error) {
        const { message } = parseLootBoyError(error);
        alert.error(
          <Alert
            title={I18n.t('common_login_error_message')}
            body={message}
          />,
        );
      }
    },
    [selectedProvider, apiUrl, alert],
  );

  const dismissCaptcha = useCallback(() => {
    setSelectedProvider(undefined);
  }, []);

  return {
    captcha: {
      isRequired: Boolean(selectedProvider),
      onChange: onCaptchaChange,
      dismiss: dismissCaptcha,
    },
    setSelectedProvider,
  };
}
